import React, { CSSProperties } from 'react';
import { Card as AntCard, CardProps as AntCardProps } from 'antd';
import { defaultPaddings } from 'constants/defaultPaddings';
import { useIsDesktop, useIsTabletUp } from 'hooks/useResponsive';
import { normalizeProp } from 'utils';
import styles from './Card.module.scss';

type CardStyle = CSSProperties & {
  '--card-padding': string;
};

export interface CardProps extends AntCardProps {
  className?: string;
  padding?: string | number | [number, number];
  autoHeight?: boolean;
}

export const Card: React.FC<CardProps> = ({
  className,
  padding,
  size,
  autoHeight = true,
  children,
  ...props
}) => {
  const isTablet = useIsTabletUp();
  const isDesktop = useIsDesktop();

  return (
    <AntCard
      size={size ? size : isTablet ? 'default' : 'small'}
      className={[styles.card, autoHeight && styles.autoHeight, className]
        .filter(Boolean)
        .join(' ')}
      bordered={false}
      {...props}
      style={
        {
          ...props.style,
          '--card-padding': normalizeProp(
            padding || padding === 0
              ? padding
              : (isDesktop && defaultPaddings.desktop) ||
                  (isTablet && defaultPaddings.tablet) ||
                  defaultPaddings.mobile
          ),
        } as CardStyle
      }
    >
      {children}
    </AntCard>
  );
};
